export enum KeyManager {
  Native = 'native',
  KeepKey = 'keepkey',
  MetaMask = 'metamask',
  Portis = 'portis',
  Demo = 'demo',
  XDefi = 'xdefi',
}
